module.exports = __webpack_public_path__ + "img/5.e994a75b.png";